// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/968e2b6d3442485b107d.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"c2b30f4eebb3324166a9","166":"95effa07401c86647e86","167":"936629572e1ad807d4ce"}[chunkId] + ".chunk.js";
};